const PROFIL_ECRITURE = {
	DEPENSE: {
		SAI_LIB: 'DSL',
		ORD_FONC: 'DOF',
		ORD_INV_AVEC_INVENT: 'DOIAI',
		ORD_INV_SANS_INVENT: 'DOISI',
		MARCHE_FONC: 'DMF',
		MARCHE_INV_AVEC_INVENT: 'DMIAI',
		MARCHE_INV_SANS_INVENT: 'DMISI',
		MARCHE_INV_AVANCE_FORFAIT: 'DMIAF',
		MARCHE_RET_GARANT_MANDAT_DIST: 'DMRGMD',
		MARCHE_DERNIER_ACOMPTE: 'DMDA',
		REGIE: 'DR',
		ANNUL_REDUC_MANDAT_EXE_COURANT: 'DARMEC',
		ANNUL_TITRE_FONCT_EXE_ANTERIEUR: 'DATEAF',
		ANNUL_TITRE_INVES_EXE_ANTERIEUR: 'DATEAI',
		ADMISSIONS_NON_VALEUR: 'DANV',
		LIEE_EMPRUNT: 'DE',
		RELEVANT_PAIE_INDIVIDUEL: 'DPMI',
		RELEVANT_PAIE_COLLECTIF: 'DPMC',
		FONCT_EMISE_APRES_PAIEMENT: 'DFAP',
		INVES_AVEC_INFO_INV_EMISE_AP_PAIEMENT: 'DIAIEAP',
		INVES_SANS_INFO_INV_EMISE_AP_PAIEMENT: 'DISIEAP',
		REGIE_EMISE_AP_PAIEMENT: 'DREAP',
		LIEE_EMPRUNT_EMISE_AP_PAIEMENT: 'DEEAP',
		TRAV_REGIE_AVEC_INFO_INV: 'DTRI',
		TRAV_REGIE_SANS_INFO_INV: 'DTRSI',
		ORDRE_BUDG_SECT_A_SECT_INVES_AVEC_INFO_INV: 'DOBSSIAI',
		ORDRE_BUDG_SECT_A_SECT_INVES_SANS_INFO_INV: 'DOBSSISI',
		ORDRE_BUDG_SECT_A_SECT_FONCT_AVEC_INFO_INV: 'DOBSSFAI',
		ORDRE_BUDG_INTERIEUR_SECT_INVES_AVEC_INFO_INV: 'DOBISIAI',
		ORDRE_BUDG_INTERIEUR_SECT_INVES_SANS_INFO_INV: 'DOBISISI',
		CREANCE_ETEINTE: 'DCE',

		// OPO
		OPO_FONC: 'DOPOF',
		OPO_INV: 'DOPOI',
		OPO_AVANCE_MARCHE_FONC: 'DOPOAMF',
	},
	RECETTE: {
		SAI_LIB: 'RSL',
		ORD_FONC: 'ROF',
		TITRE_RECAP_ROLE: 'RTRAR',
		ORD_INV_AVEC_INVENT: 'ROIAI',
		ORD_INV_SANS_INVENT: 'ROISI',
		MARCHE: 'RM',
		REGIE: 'RR',
		LIEE_EMPRUNT: 'RE',
		ANNUL_REDUC_TITRE_EXE_COURANT: 'RARTEC',
		ANNULANT_MANDAT_FONCT_EXERCICE_ANTERIEUR: 'RAMEAF',
		ANNULANT_MANDAT_INVEST_EXE_ANTERIEUR: 'RAMEAI',
		FONC_EMIS_APRES_ENCAISSEMENT: 'RFEAE',
		INVEST_AVEC_INFO_INV_EMISE_APRES_PAIEMENT: 'RIAIEAE',
		INVEST_SANS_INFO_INV_EMISE_APRES_PAIEMENT: 'RISIEAE',
		REGIE_EMISE_APRES_ENCAISSEMENT: 'RREAE',
		LIEE_EMPRUNT_EMISE_APRES_ENCAISSEMENT: 'REEAE',
		AFFECTATION_RESULTAT: 'RAR',
		TRAVAUX_REGIE: 'RTR',
		ORDRE_BUDG_SECT_A_SECT_INVES_AVEC_INFO_INV: 'ROBSSIAI',
		ORDRE_BUDG_SECT_A_SECT_INVES_SANS_INFO_INV: 'ROBSSISI',
		ORDRE_BUDG_SECT_A_SECT_FONCT_AVEC_INFO_INV: 'ROBSSFAI',
		ORDRE_BUDG_INTERIEUR_SECT_INVES_AVEC_INFO_INV: 'ROBISIAI',
		ORDRE_BUDG_INTERIEUR_SECT_INVES_SANS_INFO_INV: 'ROBISISI',
	},
} as const;

export default PROFIL_ECRITURE;
